export const ROLES = {
  ADMIN: 'admin',
  DEPARTMENT_HEAD: 'department_head',
  USER: 'user',
  GUEST: 'guest'
};

export const RESEARCH_TYPES = {
  THESIS: 'thesis',
  DISSERTATION: 'dissertation',
  RESEARCH_PAPER: 'research_paper',
  CONFERENCE_PAPER: 'conference_paper',
  PROJECT_REPORT: 'project_report'
};

export const DEPARTMENTS = [
  'Computer Science',
  'Electrical Engineering',
  'Civil Engineering',
  'Mechanical Engineering',
  'Chemical Engineering',
  'Business Administration',
  'Economics',
  'Law',
  'Medicine',
  'Agriculture'
];

export const ACCESS_LEVELS = {
  PUBLIC: 'public',
  RESTRICTED: 'restricted'
};

export const PAGINATION = {
  ITEMS_PER_PAGE: 10
};